import React, {
    useCallback,
    useState,
} from 'react';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { buildWordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import Image from '@app/components/Image/Image';
import { IAchievementItemApiModel } from '@app/models/features/course';
import AchievementModal from '../AchievementModal/AchievementModal';
import styles from './achievementItem.module.scss';

/**
 * Компонент для отрисовки блока с ачивками пользователя
 */
const AchievementItem = (props: IAchievementItemApiModel) => {
    const {
        achieved,
        icon,
        title,
        preview_description,
        investors_count,
    } = props;

    const [ isShowModal, setShowModal ] = useState(false);

    const didDetailInfoModalOpened = useCallback(() => {
        setShowModal(true);
    }, []);

    const didDetailInfoModalClosed = useCallback(() => {
        setShowModal(false);
    }, []);

    const wrapperClassName = (defaultAward = false) => buildClassNames(styles, [
        'wrapper',
        defaultAward && 'wrapper--default',
    ]);

    return (
        <>
            <div onClick={didDetailInfoModalOpened} className={wrapperClassName(!achieved)}>
                <div className={styles['image']}>
                    {icon && <Image src={icon} alt="" fill />}
                </div>
                <div className={styles['title']}>{title}</div>
                <div className={styles['text']}>{preview_description}</div>
                <div className={styles['investors_block']}>
                    {investors_count > 0 &&
                        <>у {investors_count} {buildWordForm(investors_count, ['инвестора', 'инвесторов', 'инвесторов'])}</>
                    }
                </div>
            </div>
            <AchievementModal
                isOpen={isShowModal}
                onClose={didDetailInfoModalClosed}
                {...props}
            />
        </>
    );
};

export default AchievementItem;
